import { SET_SHOW_GEOCODE_RESULTS } from '../actionTypes';
import { createProjectModalActions } from '../reducer';

export default (value) =>
    createProjectModalActions[SET_SHOW_GEOCODE_RESULTS](value);
